import styled from 'styled-components';

const FormError = styled.div`
	margin: 5px 0;
	color: #d52424;
	font-size: 1.2rem;
`;

export default FormError;
